import { jsx as n, jsxs as R } from "react/jsx-runtime";
import { clsx as b } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { RocheUIButtonType as f } from "../button/roche-button-types.js";
import { RocheUIIcon as j } from "../icon/roche-icon.js";
import t from "./roche-text-link.module.scss.js";
import { RocheUITextLinkType as y } from "./roche-text-link.types.js";
const g = ({
  href: o,
  lang: m,
  hrefLang: p,
  text: x,
  slot: k,
  target: h,
  leftIcon: s,
  rightIcon: l,
  label: _,
  visuallyHiddenText: c,
  type: e,
  size: r,
  onButtonClick: d,
  buttonType: N = f.BUTTON,
  onTextLinkClick: T
}) => {
  const i = o ? "a" : "button", u = o ? { href: o, lang: m, target: h, hrefLang: p } : {}, a = (I) => {
    const U = e === y.NEWS_PAGE;
    return /* @__PURE__ */ n("span", { className: t["text-link__icon-container"], children: /* @__PURE__ */ n(j, { icon: I, height: U ? "14px" : "24px" }) });
  };
  return /* @__PURE__ */ n(
    "span",
    {
      className: b(t["text-link"], e && t[`text-link--${e}`], r && t[` text-link--${r}`]),
      slot: k,
      children: /* @__PURE__ */ R(
        i,
        {
          className: t["text-link__link"],
          ...u,
          "aria-label": _,
          onClick: i === "a" ? T : d,
          type: i === "button" ? N : void 0,
          children: [
            s && a(s),
            /* @__PURE__ */ n("span", { className: t["text-link__text"], children: x }),
            c && /* @__PURE__ */ n("span", { className: t["text-link__visually-hidden"], children: c }),
            l && a(l)
          ]
        }
      )
    }
  );
};
export {
  g as RocheUITextLink
};
